import Dropdown from "./modules/Dropdown";
import Tooltip from "./modules/Tooltip";

Dropdown();
Tooltip();
